// extracted by mini-css-extract-plugin
export var sliderRange = "_l3-2";
export var sliderRoot = "_l3-0";
export var sliderThumb = "_l3-3";
export var sliderTrack = "_l3-1";